module.exports = "./../img/favicons/apple-icon-76x76.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicons/apple-icon-76x76.png
// module id = 143
// module chunks = 0